<template>
  <div class="submit-query-container" id>
    <div class="otp-leadform-signin">
      <div class="user-info-suggestion">
        <div class="user-details">
          <!-- <div class="go-back-icon">
            <span class="icon icon-left"></span>
          </div> -->
          <div class="user-image">
            <img src="../../../static/Images//user.png" alt="user" />
          </div>
          <div class="user-description">
            <p class="name" v-text="formData.customerName"></p>
            <p class="email-number">
              <span v-text="formData.customerEmailId + ' /'"></span>
              <span class="pal5" v-text="'+' + formData.customerIsdCode + ' - ' + formData.customerMobile"></span>
            </p>
          </div>
        </div>
        <div class="users-exist-info">
          <p class="existing-heading">Please verify your mobile number</p>
          <p class="password-heading">
            An OTP (valid for next 15 mins) has been sent to you on your Mobile number</p>
          <div class="group-fields pt45">
            <div class="input-group">
              <input id="leadOTPValidation" type="text" class="form-field" v-model="otp" :class="{'has-value': otp}" @input="$v.otp.$touch()" autocomplete="off">
              <label for="leadOTPValidation">Enter Mobile OTP</label>
            </div>
            <p class="field-error clear-both" v-if="$v.otp.$error">Please enter valid OTP.</p>
            <!-- <p class="field-error clear-both" v-else-if="messages.wrongOTP">The OTP is incorrect or has expired. Try again or generate a new OTP using the link below.</p>
            <p class="otp-resend" v-if="messages.OTPResent">Resent the OTP on your mobile number. Please check</p> -->
          </div>
          <!-- <div class="otp-resend-info">
            <p class="info-text">Did not receive your OTP ? you can request for another.</p>

            <button class="reset-otp fll resend-otp-btn" @click="resendOTP">
              <i class="icon icon-reload"></i>Resend OTP
            </button>
          </div> -->

          <div class="otp-resend-error-info" v-if="messages.wrongOTP">
            <p class="info-text">The OTP is incorrect or has expired. Try again or generate a new OTP.</p>

            <button class="reset-otp fll resend-otp-btn" @click="resendOTP">
              <i class="icon icon-reload"></i>Resend OTP
            </button>
          </div>

          <div class="otp-resend-success-info" v-if="messages.OTPResent">
            <p class="info-text">Resent the OTP on your mobile number. Please check.</p>
          </div>

          <p class="info-short pb25">By clicking Submit, I agree to Yatra.com
            <a href="https://www.yatra.com/online/terms-of-service.html">Terms of Use</a> and
            <a href="https://www.yatra.com/online/privacy-policy.html">Privacy Policy</a>.</p>
          <button class="btn btn-primary fll" @click="verifyOTP" :class="{'invalidForm': $v.otp.$invalid}" :disabled="$v.otp.$invalid">Submit</button>

          <!-- <button class="reset-otp fll" v-if="messages.wrongOTP" @click="resendOTP">Resend OTP</button> -->
        </div>
      </div>

      <div class="suggestions-yt">
        <p class="heading">Why Travel with us ?</p>
        <ul class="content-container ">
          <li class="col-2">
            <i class="icon icon-best-price"></i>
            <p class="title"> Best Price</p>
            <p class="subtext">A marketplace of suppliers </p>
          </li>
          <li class="col-2">
            <i class="icon icon-customization"></i>
            <p class="title"> Customization</p>
            <p class="subtext">Real time
              <br>end to end customization </p>
          </li>
        </ul>
        <ul class="content-container">
          <li class="col-2">
            <i class="icon icon-booking-ease"></i>
            <p class="title"> Booking with Ease</p>
            <p class="subtext">Stay in touch with our expert on live chat </p>
          </li>
          <li class="col-2">
            <i class="icon icon-chices"></i>
            <p class="title"> Plentiful Choices</p>
            <p class="subtext">Always get whats you want </p>
          </li>

        </ul>
      </div>
    </div>
  </div>
</template>

<script>
/* global yt_adobe */

import addDigitalDataObject from '../../common/tracking'
import axios from 'axios'
import URLs from '../../common/URLStore'
import { numeric, required, minLength, maxLength } from 'vuelidate/lib/validators'

export default {
  props: {
    successCallback: {
      required: true,
      default: null
    },
    formData: {
      required: true,
      default: {}
    }
  },
  data: function() {
    return {
      otp: '',
      messages: {
        wrongOTP: false,
        OTPResent: false,
        errorSendingOTP: false
      }
    }
  },
  created: function() {
    // Adobe tracking on load of otp pop up submit_tracking#4
    if (typeof yt_adobe !== 'undefined' && typeof yt_adobe.track == 'function') {
      var obj = addDigitalDataObject()
      obj.page.pageInfo.popName = 'lead form otp'
      yt_adobe.track('popup-load', obj)
    }

    this.requestOTP(this.formData)
  },
  watch: {
    otp: function(newValue) {
      this.otp = this.otp ? this.otp.trim() : ''
      var otp = this.otp
      if (otp && isNaN(Number(otp))) {
        this.otp = otp.substring(0, otp.length - 1)
      } else if (otp) {
        if (otp.length > 6) {
          this.otp = otp.substring(0, 6)
        }
      }
    }
  },
  methods: {
    resetOTPFlags: function() {
      this.messages.wrongOTP = false
      this.messages.OTPResent = false
      this.messages.errorSendingOTP = false
    },
    resendOTP: function() {
      this.otp = ''
      this.messages.wrongOTP = false
      this.messages.OTPResent = true
      this.$v.$reset()
      this.requestOTP(this.formData)

      // Adobe tracking on click of resend otp submit_tracking#6
      if (typeof yt_adobe !== 'undefined' && typeof yt_adobe.track == 'function') {
        var obj = addDigitalDataObject()
        obj.customLinkName = 'lead form otp resend'
        yt_adobe.track('custom-link-click', obj)
      }
    },
    requestOTP: function(formData) {
      axios
        .post(URLs.sendOTP, { mobile: formData.customerMobile, isdCode: formData.customerIsdCode.split(' ').join('') })
        .then(resp => {
          this.interactionInfo = resp.data
          // this.messages.OTPResent = false
        })
        .catch(() => {
          this.messages.errorSendingOTP = false
        })
    },
    verifyOTP: function() {
      this.resetOTPFlags()
      let vm = this
      vm.$emit('showLoader')
      axios.post(URLs.verifyOTP, { mobile: this.formData.customerMobile, isdCode: this.formData.customerIsdCode, interactionId: this.interactionInfo.interactionId, otp: this.otp }).then(resp => {
        if (resp.data.status == 'SUCCESS' && resp.data.isOTPVeried) {
          this.successCallback()
            .then(resp => {
              vm.$emit('changeView', resp)
              vm.$emit('hideLoader')
            })
            .catch(() => {
              vm.$emit('hideLoader')
            })
          var otpStatus = 'successful'
        } else {
          vm.$emit('hideLoader')
          this.messages.wrongOTP = true
          otpStatus = 'failure'
        }

        // Adobe tracking on click of enter otp(if otp is correct or incorrect) submit_tracking#5
        if (typeof yt_adobe !== 'undefined' && typeof yt_adobe.track == 'function') {
          var obj = addDigitalDataObject()
          obj.customLinkName = 'lead form otp ' + otpStatus
          yt_adobe.track('custom-link-click', obj)
        }
      })
    }
  },
  validations: {
    otp: {
      required,
      numeric,
      minLength: minLength(6),
      maxLength: maxLength(6)
    }
  }
}
</script>

<style lang="scss" scoped>
.go-back-icon {
  float: left;
  display: block;
  width: 7%;
  position: relative;
  top: 20px;
  .icon-left {
    padding: 7px 5px;
  }
}

.go-back-icon:hover {
  .icon-left {
    background: lightgrey;
    border-radius: 50%;
  }
}

.reset-otp {
  border: none;
  background-color: white;
  color: #4197cd;
  font-size: 14px;
  margin-left: 45px;
  display: block;
  margin-top: 15px;
  cursor: pointer;
  font-family: 'Rubik Medium';
}

.otp-resend {
  font-size: 12px;
  margin-top: 10px;
  color: green;
  float: left;
  clear: both;
}

#leadOTPValidation {
  width: 265px;
}

.clear-both {
  clear: both;
}

.otp-resend-info {
  float: left;
  font-size: 13px;
  width: 100%;
  border: 1px solid #92cee8;
  background: #03a9f424;
  height: 45px;
  line-height: 42px;
  margin-bottom: 15px;
  border-radius: 4px;
  padding: 0px 10px;

  .info-text {
    float: left;
    color: #064d6f;
    padding-right: 15px;
  }

  .resend-otp-btn {
    float: right !important;
    margin: 0px;
    border: 1px solid #03a9f487;
    color: #ffffff;
    padding: 5px 8px;
    border-radius: 4px;
    background: #2abdff;
    margin-top: 7px;
    font-size: 12px;
    height: 30px;
    line-height: 20px;
  }

  .icon-reload {
    font-size: 14px;
  }
}

.otp-resend-error-info {
  @extend .otp-resend-info;
  border: 1px solid #f5bbbb;
  background: #f34f4f24;

  .info-text {
    color: #bb0000;
  }

  .resend-otp-btn {
    background: #f34f4f;
    border-color: #f34f34;
  }
}

.otp-resend-success-info {
  @extend .otp-resend-info;
  border: 1px solid #73d8a0;
  background: #dbfde2;

  .info-text {
    color: #337156;
  }

  .resend-otp-btn {
    background: #f34f4f;
    border-color: #f34f34;
  }
}

.group-fields.pt45 {
  padding-top: 45px;
}

.info-short.pb25 {
  padding-bottom: 25px;
}
</style>



// WEBPACK FOOTER //
// src/components/lead-form/otp-verification.vue